import ResultCard from '@components/phs/pst/results/result/common/resultCard';
import ResultTable from '@components/phs/pst/results/result/resultInfo/resultTable';
import EmptyHistory from '@components/phs/pst/results/result/resultInfo/emptyHistory';
import HistoryChart, { ChartData } from '@components/phs/pst/results/result/resultInfo/historyChart';
import { ScoreTooltip, PassedStepToolTip } from '@components/phs/pst/results/result/resultInfo/tooltip';
import { PstResultVO } from '@domain/vo/phs/pst/result/PstResultVO';
import classnames from 'classnames/bind';
import styles from './resultInfo.module.scss';

const cx = classnames.bind(styles);

const ColumnsData = ['0점', '20점', '40점', '60점', '80점', '100점'];

interface ResultInfoProps {
  pstResult: PstResultVO;
}

const ResultInfo = ({ pstResult }: ResultInfoProps) => {
  const { resultHistories } = pstResult;

  const isEmpty = !resultHistories || !resultHistories.length;

  const getColumns = () => ColumnsData;

  const getRows = () => {
    return resultHistories.map((result) => `${result.priority + 1}회차`);
  };

  const getChartData = (): ChartData[] => {
    return resultHistories.map((result) => {
      const { score } = result;

      return {
        passedStepToolTip: <PassedStepToolTip data={result} />,
        column: score / 20,
        scoreTooltip: (isLast: boolean) => <ScoreTooltip type={isLast ? 'gray' : 'white'} data={result} />,
      };
    });
  };

  return (
    <ResultCard title={'검사 결과 및 제출 히스토리'} cardType={'gray'} iconType={'result'}>
      <div className={cx('resultArea')}>
        {/* [D] 검사 결과 */}
        <div className={cx('cardInner')}>
          <strong className={cx('title')}>검사 결과</strong>
          <div className={cx('contents')}>
            <ResultTable pstResult={pstResult} />
          </div>
        </div>

        {/* [D] 제출 히스토리 */}
        <div className={cx('cardInner')}>
          <strong className={cx('title')}>제출 히스토리</strong>
          <div className={cx('contents', { empty: isEmpty })}>
            {isEmpty ? (
              <EmptyHistory />
            ) : (
              <div className={cx('chartArea')}>
                <HistoryChart
                  rows={getRows()}
                  columns={getColumns()}
                  data={getChartData()}
                  viewCount={6}
                  onIndex={resultHistories.length - 1}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ResultCard>
  );
};

export default ResultInfo;
